import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
  Avatar
} from "@mui/material";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { find } from "lodash";

import { getClassNames } from "../../Js/Common";
import ProfileInfo from "./ProfileInfo";
import ProfileActivity from "./ProfileActivity";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ProfilePageCard = () => {
  const theme = useTheme();
  const [value, setValue] = useState(0);


  // State
  const [classes, setClasses] = useState([]);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // React logic hooks
  useEffect(() => {
    const innerFunction = async () => {
      setClasses(await getClassNames(userInfo.site_uuid));
    };
    innerFunction();
  }, [userInfo]);

  // Get classes assigned to loggedin user(trainer)
  const getClassName = (ids) => {
    let allClasses = ids.map((id) => {
      let classname = find(classes, { id: id });
      if (classname) {
        return classname.value;
      }
    });

    return allClasses.join(", ");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{
      width: 600,
      '@media (min-width: 1636px)': {
        width: '60rem',
      }
    }}>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{
              bgcolor: "#DB8829", '@media (min-width: 1636px)': {
                fontSize: '1.8rem', width: '4rem',
                height: '4rem'
              }
            }}>
              {userInfo !== undefined &&
                userInfo !== null &&
                (userInfo.name.firstname
                  ? userInfo.name.firstname.toUpperCase()[0]
                  : "") +
                "" +
                (userInfo.name.lastname
                  ? userInfo.name.lastname.toUpperCase()[0]
                  : "")}
            </Avatar>
          </ListItemAvatar>
          <ListItemText>
            <Typography
              sx={{
                color: "#DB8829",
                display: "inline",
                fontSize: "1.2rem",
                fontWeight: "bold",
                '@media (min-width: 1636px)': {
                  fontSize: '2rem',
                  ml: 2
                }
              }}
            >{`${userInfo.name.firstname} ${userInfo.name.lastname}`}</Typography>
            <Typography
              sx={{
                display: "inline",
                color: "#A9A9A9",
                fontSize: "0.8rem",
                pl: 1,
                '@media (min-width: 1636px)': {
                  fontSize: '1rem',
                }
              }}
            >
              {userInfo.class_assigned
                ? `${getClassName(userInfo.class_assigned)}`
                : ``}
            </Typography>
          </ListItemText>
        </ListItem>
      </List>
      <AppBar
        elevation="0"
        position="sticky"
        sx={{
          bgcolor: "#FFF",
          borderBottom: 2,
          borderBottomColor: "#EAECEF",
          mt: 2,
        }}
      >
        <Tabs 
          value={value} 
          onChange={handleChange}
          variant="fullWidth">
          <Tab
            label="Profile"
            {...a11yProps(0)}
            sx={{
              px: 8, fontWeight: "bold",
              '@media (min-width: 1636px)': {
                fontSize: '1.6rem',
              }
            }}
          />
          {
            (userInfo.rolesInfo.title.toLowerCase() == "trainer") &&
            < Tab
              label="Activities "
              {...a11yProps(1)}
              sx={{
                px: 8, fontWeight: "bold", '@media (min-width: 1636px)': {
                  fontSize: '1.6rem',
                }
              }}
            />
          }
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <ProfileInfo></ProfileInfo>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <ProfileActivity></ProfileActivity>
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}

export default ProfilePageCard;